import './Label-3bad93c9.css';

var classes = {"Label":"prc-Label-Label--LG6X"};

export { classes as default };
